import React from 'react';
import { View, Image, ImageBackground, StyleSheet, Text } from 'react-native'
import logo from '../../images/logo.png'
import background from '../../images/background.jpg'
import TextZ from '../TextZ';

export default ({ children }) => {
    return <ImageBackground source={background} style={styles.container}>
        <View style={{
                flexDirection: 'column',
                alignItems: 'center',
                alignContent: 'center',
                flexGrow: 1,
                
            }}>
            <Image source={logo} style={{width: 200, height: 200, margin: 20}}/>
            <TextZ style={styles.text}>Loading...</TextZ>
        </View>
    </ImageBackground>
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
    },
    text: { 
        textAlign: 'center', 
        alignSelf: 'center',
        flex: 1,
        fontSize: 20,
        color: 'white'
    }
});
  
  